import { Translation, QRType } from '../types';

export const hi: Translation = {
  nav: {
    generator: 'जेनेरेटर',
    scanner: 'स्कैनर',
    mobile: 'मोबाइल पर आज़माएँ',
    blog: 'ब्लॉग',
    langSelect: 'भाषा चुनें',
  },
  pageTitles: {
    generator: 'मुफ़्त ऑनलाइन क्यूआर कोड जनरेटर',
    scanner: 'ऑनलाइन क्यूआर कोड स्कैनर',
    textToQr: 'टेक्स्ट से क्यूआर कोड कन्वर्टर',
    linkToQr: 'लिंक से क्यूआर कोड जनरेटर',
  },
  pageMeta: {
    generator: {
      title:
        'फ्री QR कोड जेनरेटर — ऑनलाइन QR कोड बनाएं (कोई साइनअप नहीं, बिना वॉटरमार्क, PNG/SVG/PDF) | YesQRCode',
      description:
        'YesQRCode के साथ ऑनलाइन मुफ्त में QR कोड बनाएं। URL, टेक्स्ट, WiFi, vCard और बहुत कुछ जनरेट करें। उच्च गुणवत्ता वाले PNG, SVG या PDF डाउनलोड करें। बिना साइनअप, बिना लॉगिन, बिना वॉटरमार्क — तेज़, सुरक्षित और हमेशा मुफ्त।',
      keywords: [
        'क्यूआर कोड जेनरेटर',
        'फ्री क्यूआर कोड जेनरेटर',
        'ऑनलाइन क्यूआर कोड बनाएं',
        'क्यूआर कोड मेकर',
        'क्यूआर कोड png',
        'क्यूआर कोड svg',
        'क्यूआर कोड pdf',
        'वाईफाई क्यूआर कोड जेनरेटर',
        'vcard क्यूआर कोड जेनरेटर',
        'बिना साइनअप क्यूआर जेनरेटर',
        'मुफ्त क्यूआर कोड',
        'कस्टम क्यूआर कोड',
      ],
    },
    scanner: {
      title:
        'ऑनलाइन QR कोड स्कैनर — इमेज या कैमरा से स्कैन करें (सुरक्षित, बिना साइनअप) | YesQRCode',
      description:
        'अपने ब्राउज़र में मुफ्त में QR कोड और बारकोड स्कैन करें। कोई इमेज अपलोड करें या कैमरा का उपयोग करें। सारा प्रोसेस लोकली होता है, कोई अपलोड नहीं। सुरक्षित, तेज, बिना साइनअप, बिना लॉगिन और पूरी तरह मुफ्त।',
      keywords: [
        'क्यूआर कोड स्कैनर',
        'ऑनलाइन क्यूआर कोड स्कैन करें',
        'ऑनलाइन क्यूआर रीडर',
        'इमेज से क्यूआर स्कैन करें',
        'बारकोड ऑनलाइन स्कैन करें',
        'सुरक्षित क्यूआर स्कैनर',
        'क्यूआर स्कैनर बिना अपलोड',
        'फ्री क्यूआर स्कैनर',
        'ब्राउज़र क्यूआर स्कैनर',
        'बिना साइनअप क्यूआर स्कैनर',
        'बिना लॉगिन क्यूआर स्कैनर',
      ],
    },
    textToQr: {
      title: 'टेक्स्ट से QR कोड कन्वर्टर — साधारण टेक्स्ट को तुरंत QR कोड में बदलें | YesQRCode',
      description:
        'किसी भी नोट, संदेश या टेक्स्ट को ऑनलाइन QR कोड में बदलें। रंग, फ्रेम और लोगो को कस्टमाइज़ करें और PNG, SVG या PDF फ़ाइलें बिना साइनअप के डाउनलोड करें।',
      keywords: [
        'टेक्स्ट से qr कोड',
        'text to qr hindi',
        'टेक्स्ट qr जेनरेटर',
        'qr कोड टेक्स्ट ऑनलाइन',
        'संदेश से qr कोड',
        'नोट से qr कोड',
        'टेक्स्ट qr मुफ्त',
        'टेक्स्ट qr बिना साइनअप',
        'text qr converter',
        'qr code text hindi',
      ],
    },
    linkToQr: {
      title: 'लिंक से QR कोड जनरेटर — URL को QR कोड में बदलें (UTM तैयार) | YesQRCode',
      description:
        'कोई भी वेबसाइट या कैंपेन URL पेस्ट करें और तुरंत कस्टम QR कोड प्राप्त करें। रंग, लोगो और फ्रेम सेट करें और उच्च-रिज़ॉल्यूशन PNG, SVG या PDF बिना लॉगिन के डाउनलोड करें।',
      keywords: [
        'लिंक से qr कोड',
        'url qr जेनरेटर',
        'वेबसाइट qr कोड',
        'url को qr में बदलें',
        'utm qr कोड',
        'लिंक qr बनाएं',
        'मुफ्त url qr कोड',
        'कैम्पेन qr कोड',
        'url qr बिना साइनअप',
        'qr code for link hindi',
      ],
    },
  },
  hero: {
    title: 'बनाएँ. स्कैन करें. तैयार करें.',
    subtitle: 'हर टीम के लिए प्रीमियम क्यूआर कोड टूल।',
    desc: 'लोगो, रंग और हाई-रिज़ॉल्यूशन आउटपुट के साथ सेकंडों में कस्टम क्यूआर कोड तैयार करें।',
  },
  info: {
    helpTitle: 'सहायता केंद्र',
    helpSubtitle: 'अक्सर पूछे जाने वाले प्रश्न और सपोर्ट',
    contactTitle: 'हमसे संपर्क करें',
    contactSubtitle: 'हम जल्द जवाब देंगे।',
    privacyTitle: 'गोपनीयता नीति',
    termsTitle: 'सेवा की शर्तें',
  },
  contactForm: {
    name: 'नाम',
    email: 'ईमेल',
    message: 'संदेश',
    send: 'संदेश भेजें',
    orEmail: 'या सीधे मेल करें',
    sending: 'भेजा जा रहा है...',
    successTitle: 'संदेश भेजा गया!',
    successMessage: 'धन्यवाद। हम शीघ्र उत्तर देंगे।',
    sendAnother: 'एक और संदेश भेजें',
    errorMessage: 'हम अभी आपका संदेश भेज नहीं पाए। कृपया support@yesqrcode.com पर ईमेल करें।',
  },
  generator: {
    highlights: {
      title: 'निजी, ब्रांड-रेडी QR कोड बनाएं — हमेशा मुफ़्त।',
      subtitle: 'हर वर्कफ़्लो के लिए तेज़, सुरक्षित और लचीला QR टूल।',
      desc: 'खाते, वॉटरमार्क या डेटा अपलोड के बिना उच्च-गुणवत्ता वाले QR कोड बनाएँ और स्कैन करें।',
      items: [
        {
          title: 'प्राइवेसी-फर्स्ट, ऑन-डिवाइस जनरेशन',
          desc: 'QR कोड पूरी तरह लोकल बनते हैं — न अपलोड, न ट्रैकिंग, न डेटा स्टोरेज।',
        },
        {
          title: 'हर उपयोग के लिए समृद्ध सुविधाएँ',
          desc: 'URL, WiFi, vCard, बारकोड, लोगो, ग्रेडिएंट, फ्रेम — सब कुछ एक ही जगह।',
        },
        {
          title: 'मोबाइल-फ्रेंडली अनुभव',
          desc: 'फोन और टच इंटरफ़ेस के लिए अनुकूलित ताकि बनाना और स्कैन करना सरल रहे।',
        },
        {
          title: 'हमेशा मुफ़्त, व्यावसायिक उपयोग के लिए सुरक्षित',
          desc: 'न अकाउंट, न वॉटरमार्क, न स्कैन सीमा — हर टीम के लिए भरोसेमंद समाधान।',
        },
      ],
    },
    featureSuite: {
      title: 'पूर्ण प्राइवेसी-फर्स्ट QR सूट',
      subtitle: 'साफ़, ब्रांडेड और उच्च-गुणवत्ता वाले QR कोड बनाने के लिए हर चीज़ एक ही जगह।',
      categories: [
        {
          title: 'सभी ज़रूरी QR प्रकार',
          body: 'URL, टेक्स्ट, WiFi, ईमेल, फ़ोन, SMS, vCard, सोशल लिंक, YouTube, बारकोड — स्थायी स्टैटिक कोड।',
          items: [],
        },
        {
          title: 'ब्रांडिंग और डिज़ाइन',
          body: 'लोगो-सुरक्षित कोड, ग्रेडिएंट, फ्रेम, आकृतियाँ, कोने और स्कैन-अनुकूल लेआउट।',
          items: [],
        },
        {
          title: 'आउटपुट और गुणवत्ता',
          body: 'उच्च गुणवत्ता वाले PNG, SVG और PDF निर्यात, प्रिंट व डिजिटल के प्रीसेट के साथ।',
          items: [],
        },
        {
          title: 'वैश्विक और उपयोगिता',
          body: 'बहुभाषी UI, मोबाइल-प्रथम डिज़ाइन और ऑफ़लाइन-फ्रेंडली वर्कफ़्लो।',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Trusted by creators, teams, and brands',
      subtitle:
        'YesQRCode is designed to be lightweight, predictable, and safe for long-running campaigns — with no accounts, no vendor lock-in, and no hidden limitations.',
      items: [
        'Zero onboarding',
        'Predictable static codes',
        'Enterprise-safe: no cloud processing',
        'Consistent branding across all assets',
      ],
    },
    sectionContent: 'कंटेंट',
    sectionColors: 'रंग',
    sectionLogo: 'लोगो',
    sectionFrame: 'फ्रेम',
    sectionDesign: 'डिज़ाइन',
    sectionCorrection: 'एरर करेक्शन',
    labelUrl: 'वेबसाइट URL',
    labelText: 'सादा पाठ',
    labelSsid: 'नेटवर्क नाम (SSID)',
    labelPassword: 'पासवर्ड',
    labelEncryption: 'एन्क्रिप्शन',
    labelFgColor: 'मुख्य रंग',
    labelBgColor: 'पृष्ठभूमि रंग',
    labelFrameText: 'फ्रेम टेक्स्ट',
    labelFrameColor: 'फ्रेम रंग',
    placeholder: 'यहाँ अपना कंटेंट लिखें...',
    placeholders: {
      url: 'https://example.com',
      text: 'यहाँ टेक्स्ट लिखें',
      email: 'aap@example.com',
      subject: 'विषय',
      message: 'आपका संदेश...',
      phone: '+91 90000 00000',
      ssid: 'MyWiFi',
      password: 'पासवर्ड',
      barcode: '123456789012',
    },
    download: 'PNG डाउनलोड करें',
    downloadSvg: 'SVG डाउनलोड करें',
    generateButton: 'क्यूआर कोड बनाएँ',
    copy: 'SVG कॉपी करें',
    uploadLogo: 'इमेज अपलोड करें',
    preview: 'प्रीव्यू',
    lowQuality: 'लो क्वालिटी',
    highQuality: 'हाई क्वालिटी',
    foreverFree: 'हमेशा मुफ़्त • बिना साइनअप • व्यावसायिक उपयोग संभव',
    barcodeWarning: 'बारकोड के लिए लोगो या फ्रेम विकल्प उपलब्ध नहीं हैं।',
    barcodeColors: 'आप नीचे रंग बदल सकते हैं।',
    frameStyles: {
      none: 'कोई नहीं',
      simple: 'सिंपल',
      balloon: 'बलून',
      box: 'बॉक्स',
      badge: 'बैज',
      polaroid: 'पोलारॉयड',
      phone: 'फोन',
      header: 'हेडर',
      corner: 'कॉर्नर',
    },
    vCard: {
      firstName: 'पहला नाम',
      lastName: 'अंतिम नाम',
      mobile: 'मोबाइल',
      phone: 'टेलीफ़ोन',
      fax: 'फ़ैक्स',
      email: 'ईमेल',
      company: 'कंपनी',
      job: 'पद',
      street: 'सड़क',
      city: 'शहर',
      zip: 'पिन कोड',
      state: 'राज्य',
      country: 'देश',
      website: 'वेबसाइट',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'टेक्स्ट',
      [QRType.EMAIL]: 'ईमेल',
      [QRType.PHONE]: 'फोन',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'वाई-फाई',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'बारकोड',
    },
    guide: {
      title: 'कस्टम क्यूआर कोड कैसे बनाएं?',
      steps: [],
    },
    gettingStarted: {
      title: 'चार आसान चरण',
      steps: [
        {
          title: 'कंटेंट चुनें',
          text: 'QR प्रकार (URL, टेक्स्ट, ईमेल आदि) चुनें और सभी आवश्यक फ़ील्ड भरें।',
        },
        {
          title: 'डिज़ाइन सेट करें',
          text: 'रंग, आकार और लोगो बदलें ताकि कोड ब्रांडिंग से मेल खाए।',
        },
        {
          title: 'कोड जनरेट करें',
          text: 'रेज़ोल्यूशन निर्धारित करें, लाइव प्रीव्यू देखें और स्कैन करके जाँच लें।',
        },
        {
          title: 'डाउनलोड व उपयोग',
          text: 'PNG या SVG फ़ाइल डाउनलोड करें और उसे प्रिंट या डिजिटल चैनलों में उपयोग करें।',
        },
      ],
    },
    about: {
      title: 'व्यावसायिक गुणवत्ता का मुफ्त क्यूआर जनरेटर',
      subtitle:
        'YesQRCode आपके लिए हाई-रेज़ोल्यूशन निर्यात, असीमित स्कैन और पूरी कस्टमाइज़ेशन लाता है।',
      features: [
        'सोशल मीडिया और लैंडिंग पेज लिंक',
        'डिजिटल vCard',
        'पूरी तरह अनुकूलन योग्य रंग',
        'प्रिंट फ़्रेंडली फॉर्मेट',
        'व्यावसायिक उपयोग की अनुमति',
        'कोड कभी expire नहीं होते',
      ],
      content: [
        {
          title: 'असीमित अवधि',
          body: 'सभी स्टेटिक क्यूआर हमेशा सक्रिय रहते हैं—कोई समय सीमा या स्कैन सीमा नहीं।',
        },
        {
          title: 'लोगो के साथ क्यूआर',
          body: '30% तक एरर करेक्शन का लाभ लेकर सुरक्षित रूप से लोगो जोड़ें।',
        },
        {
          title: 'रंग और फ्रेम कंट्रोल',
          body: 'अनूठे आकार, ग्रेडिएंट और फ्रेम जोड़कर कोड को ध्यान आकर्षित करने वाला बनाएं।',
        },
        {
          title: 'प्रिंट के लिए तैयार',
          body: 'उच्च गुणवत्ता वाले PNG या स्केलेबल SVG फ़ाइलें बड़े प्रिंट और पैकेजिंग के लिए आदर्श हैं।',
        },
        {
          title: 'मुक्त व्यावसायिक उपयोग',
          body: 'अपने उत्पादों, अभियानों और ऑफ़लाइन सामग्री में ‌QR को स्वतंत्र रूप से उपयोग करें।',
        },
      ],
    },
    faq: {
      title: 'अक्सर पूछे जाने वाले प्रश्न',
      items: [
        { q: 'QR कोड क्या है?', a: 'यह एक द्वि-आयामी कोड है जिसमें लिंक या पाठ सुरक्षित किया जाता है।' },
        { q: 'क्या यह पूरी तरह मुफ़्त है?', a: 'हाँ, आप असीमित क्यूआर व्यक्तिगत या व्यावसायिक उपयोग के लिए बना सकते हैं।' },
        { q: 'क्या बाद में संपादन संभव है?', a: 'स्टेटिक कोड संपादित नहीं किए जा सकते। बदलाव चाहिए तो नया कोड बनाएं।' },
        { q: 'स्कैन की सीमा क्या है?', a: 'कोई सीमा नहीं। जितनी बार चाहें स्कैन करें।' },
        { q: 'डेटा सुरक्षित है?', a: 'हाँ, हम केवल डाउनलोड को तेज़ करने के लिए इमेज अस्थायी रूप से cache करते हैं।' },
        { q: 'vCard सही नहीं दिखती?', a: 'कुछ ऐप मानक vCard फ़ॉर्मेट नहीं मानते। किसी अन्य स्कैनर से जाँच करें।' },
        {
          q: 'QR काम नहीं कर रहा?',
          a: 'टाइपिंग त्रुटियों, रंग कंट्रास्ट और लोगो हटाकर टेस्ट करने की सलाह दी जाती है।',
        },
        {
          q: 'कौन से ब्राउज़र सपोर्ट करते हैं?',
          a: 'Chrome, Firefox, Safari और Edge के नवीनतम संस्करण पूरी तरह समर्थित हैं।',
        },
      ],
    },
  },
  scanner: {
    title: 'क्यूआर और बारकोड स्कैनर',
    subtitle: 'कैमरा, इमेज अपलोड या पेस्ट से तुरंत डिकोड करें।',
    cameraPermission: 'कृपया ब्राउज़र सेटिंग्स में कैमरा अनुमति सक्षम करें।',
    result: 'परिणाम',
    copy: 'कॉपी करें',
    copied: 'कॉपी हुआ',
    open: 'लिंक खोलें',
    delete: 'हटाएँ',
    scanAgain: 'फिर से स्कैन करें',
    privacy: 'सारा प्रसंस्करण आपके ब्राउज़र में होता है। कोई फ़ाइल सर्वर पर नहीं जाती।',
    upload: 'इमेज अपलोड करें',
    paste: 'पेस्ट (Ctrl+V)',
    drop: 'इमेज यहाँ छोड़ें',
    retry: 'दोबारा प्रयास करें',
    errorAccessDenied: 'कैमरा एक्सेस अस्वीकृत',
    errorCamera: 'कैमरा की अनुमति दें और पुनः प्रयास करें।',
    initializing: 'कैमरा प्रारंभ हो रहा है...',
    cameraActive: 'कैमरा सक्रिय',
    scannedItems: 'स्कैन सूची',
    recentScans: 'हाल ही के (लोकल)',
    clickToUpload: 'अपलोड के लिए क्लिक करें',
    newBadge: 'नया',
    tabCameraMobile: 'कैमरा',
    tabCameraDesktop: 'कैमरा स्कैन',
    emptyState: {
      title: 'अभी तक कोई स्कैन नहीं',
      desc: 'इमेज अपलोड करें या कैमरा टैब का उपयोग करें।',
    },
    highlights: {
      title: 'तेज़ और निजी स्कैनिंग',
      items: [
        { title: 'डिवाइस पर डिकोडिंग', desc: 'डिफ़ॉल्ट रूप से कोई अपलोड नहीं; संवेदनशील URL और एसेट्स के लिए सुरक्षित।' },
        { title: 'मल्टी-फॉर्मैट', desc: 'QR के साथ UPC/EAN, Code 128, ITF आदि समर्थित हैं।' },
        { title: 'तीव्र क्रियाएँ', desc: 'फ़ाइलें ड्रॉप करें, स्क्रीनशॉट पेस्ट करें या तुरंत लाइव स्कैन पर स्विच करें।' },
        { title: 'मोबाइल के लिए बेहतरीन', desc: 'फोन और छोटे स्क्रीन के लिए अनुकूलित UI और कैमरा फ़्लो।' },
      ],
    },
    intro: {
      title: 'सुरक्षित ऑनलाइन स्कैनर',
      body: 'QR, UPC, EAN, ITF और अन्य फॉर्मेट सीधे ब्राउज़र में पढ़ें।',
    },
    howTo: {
      title: 'कैसे स्कैन करें',
      methods: [
        { title: 'इमेज अपलोड', steps: ['“इमेज अपलोड” पर क्लिक करें', 'फ़ाइल चुनें', 'परिणाम तुरंत देखें'] },
        { title: 'कैमरा मोड', steps: ['कैमरा टैब खोलें', 'अनुमति दें', 'कोड की ओर कैमरा रखें'] },
      ],
    },
    features: {
      title: 'मुख्य विशेषताएँ',
      items: [
        { title: 'पूरी तरह मुफ़्त', desc: 'कोई सीमा या शुल्क नहीं।' },
        { title: 'मल्टी-फॉर्मेट', desc: 'QR के साथ कोड 128, EAN, UPC आदि पढ़ता है।' },
        { title: 'गोपनीयता', desc: 'डाटा आपके डिवाइस पर रहता है।' },
      ],
    },
    useCases: {
      title: 'उपयोग के उदाहरण',
      items: [
        { title: 'मार्केटिंग एवं इवेंट', desc: 'प्रिंट सामग्री और कूपन की जाँच करें।' },
        { title: 'इन्वेंटरी टीमें', desc: 'बारकोड के माध्यम से स्टॉक अपडेट करें।' },
        { title: 'दैनिक उपयोग', desc: 'मेन्यू, Wi-Fi या फॉर्म सुरक्षित रूप से खोलें।' },
      ],
    },
    faq: {
      title: 'स्कैनर FAQ',
      items: [
        { q: 'क्या बारकोड सपोर्ट है?', a: 'हाँ, सभी लोकप्रिय 1D और 2D कोड पढ़े जा सकते हैं।' },
        { q: 'क्या स्क्रीनशॉट पेस्ट कर सकते हैं?', a: 'हाँ, Ctrl+V (या Cmd+V) दबाएँ।' },
        { q: 'क्या डेटा सुरक्षित रहता है?', a: 'हाँ, परिणाम केवल लोकल स्टोरेज में दिखाई देते हैं।' },
        { q: 'ऑफ़लाइन काम करेगा?', a: 'इमेज अपलोड ऑफ़लाइन चलता है; कैमरा मोड के लिए अनुमति और ब्राउज़र सपोर्ट चाहिए।' },
      ],
    },
  },
  blog: {
    title: 'अंतरदृष्टि और मार्गदर्शिकाएँ',
    subtitle: 'QR मार्केटिंग, डिज़ाइन और उत्पाद अपडेट पर लेख।',
    readMore: 'लेख पढ़ें',
    back: 'ब्लॉग पर लौटें',
    notFound: 'पोस्ट नहीं मिली',
  },
  common: {
    footer: 'मार्केटरों और डिज़ाइन टीमों के लिए संपूर्ण QR समाधान।',
    privacy: 'गोपनीयता',
    terms: 'शर्तें',
    contact: 'संपर्क',
    scanToOpen: 'मोबाइल पर खोलने के लिए स्कैन करें',
    help: 'सहायता',
    free: 'मुफ़्त',
    product: 'उत्पाद',
    resources: 'संसाधन',
    company: 'कंपनी',
    api: 'API (जल्द ही)',
    systemStatus: 'प्रणालियाँ सामान्य हैं',
    footerDesc:
      'सबसे तेज़ और सुरक्षित QR जेनरेटर/स्कैनर जो हमेशा के लिए मुफ़्त है – व्यक्तिगत और व्यावसायिक उपयोग के लिए उपयुक्त।',
  },
};
